/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'system': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M389.12 245.76v61.44h471.04v327.68H389.12v61.44h163.84v81.92H430.08v61.44h307.2v-61.44H614.4v-81.92h307.2V245.76zM174.08 706.56a30.72 30.72 0 1061.44 0 30.72 30.72 0 10-61.44 0z" _fill="#303133"/><path pid="1" d="M81.92 839.68h245.76V245.76H81.92v593.92zm61.44-532.48h122.88v471.04H143.36V307.2z" _fill="#303133"/>'
  }
})
